var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYkyrLogoType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "YKYR",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 166.2",
    style: {
      enableBackground: "new 0 0 400 166.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400,166.2l-27.9-40h23.5V47.1c0-25.9-21.2-47.1-47.1-47.1H264l-12.3,50.9L239.4,0h-74.2l-20.6,82.9h-0.9V0H64.8L52.5,50.9 L40.2,0H0l31.7,114.3v51.8h41.5v-51.8l29-104.7v156.5h41.5v-40h10.9v40h46l-27.9-58.1L200.6,4.9l30.4,109.4v51.8h41.5v-51.8 l29-104.7v156.5H343v-40H354v40L400,166.2L400,166.2z M343,87.3V43.6H354v43.8H343z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYkyrLogoType);
export default __webpack_public_path__ + "static/media/YKYRLogoType.f31126b8174fff5d2a4c916c1ed6a6a3.svg";
export { ForwardRef as ReactComponent };